import { observable, action, toJS, extendObservable } from "mobx"
import store from "store"
import _ from "lodash"
import shop from "shop/shop"

class SettingStore {

  @observable byName = new Map()

  constructor() {
    this.load()
  }

  load() {
    try {
      let textData = store.get( "settings" )
      if ( !textData ) return

      const data = JSON.parse( textData )
      _.map( data, ( item, key ) => {
        this.byName.set( key, item )
      } )
      this.byName.merge( data )
    } catch ( err ) {
      store.remove( "settings" )
      console.warn( "Could not restore settings from localStorage" )
      this.byName = new Map()
    }
  }

  get( key ) {
    return this.byName.get( key )
  }

  @action
  set( key, value ) {
    this.byName.set( key, value )
    this.save()
    shop.cart.setExtra( key, value )
  }

  save() {
    const json = JSON.stringify( toJS( this.byName ) );
    console.log( "save", json )
    store.set( "settings", json )
  }
}

const settingStore = new SettingStore()
window[ "settingStore" ] = settingStore

export default settingStore



// WEBPACK FOOTER //
// ./src/stores/settingStore.js